module.exports = __webpack_public_path__ + "static/img-about-6862bb875b14e6ae0e2f531c0febcb6e.png";